import axios from 'axios';
import _ from 'lodash';
import { REQUESTS_IDS_TO_CANCEL_PREVIOUS } from '../../core';

const cancelSources = []; //requestId as a key, CancelTokenSource - value

const cancelRequestById = requestId => {
    const tokenRecord = _.find(cancelSources, { requestId });
    if (tokenRecord) {
        tokenRecord.tokenSource.cancel();
        clearCancelToken(tokenRecord.requestId);
    }
};

//we need this for requests with terms is url requests
const cancelRequests = urls => {
    _.forEach(urls, url => cancelRequest(url));
};

const cancelRequest = urlStartWith => {
    _.forEach(cancelSources.slice(), record => {
        if (_.startsWith(record.requestId, urlStartWith)) {
            record.tokenSource.cancel();
            clearCancelToken(record.requestId);
        }
    });
};

const clearCancelToken = requestId => {
    _.remove(cancelSources, { requestId });
};

const getCancelToken = requestId => {
    const urlStartsWith = _.find(REQUESTS_IDS_TO_CANCEL_PREVIOUS, url => _.startsWith(requestId, url));
    if (urlStartsWith) {
        cancelRequest(urlStartsWith);
    }

    const nextCancelSource = axios.CancelToken.source();
    cancelSources.push({ requestId, tokenSource: nextCancelSource });
    return nextCancelSource.token;
};

export default { getCancelToken, cancelRequestById, clearCancelToken, cancelRequest, cancelRequests };
